(function ($) {

    const slider = {
        initPartners: function () {
            $('.partners__slider').slick({
                lazyLoad: 'progressive',
                slidesToShow: 5,
                slidesToScroll: 1,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 3000,
                infinite: true,
                responsive: [
                    {
                        breakpoint: 920,
                        settings: {
                            slidesToShow: 2.2,
                        }
                    }
                ]
            });
        },
        initQuotes: function () {
            $('.quotes-slider').slick({
                lazyLoad: 'progressive',
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true,
                centerPadding: '0px',
                dots: true,
                dotsClass: 'slick-custom-dots',
                arrows: true,
                speed: 1000,
                fade: true,
                adaptiveHeight: true,
                prevArrow: $('.slick-custom-arrows__prev'),
                nextArrow: $('.slick-custom-arrows__next'),
                responsive: [
                    {
                        breakpoint: 920,
                        settings: {
                            arrows: false,
                        }
                    }
                ]
            });
        },
        initPosts: function () {
            $('.posts-in-slider').slick({
                lazyLoad: 'progressive',
                slidesToShow: 3,
                slidesToScroll: 3,
                dots: true,
                dotsClass: 'slick-custom-dots',
                arrows: false,
                adaptiveHeight: false,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            centerPadding: '40px',
                        }
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1.1,
                            slidesToScroll: 1,
                            centerMode: false,
                            centerPadding: '20px',
                        }
                    }
                ]
            });
        },
    };
    jQuery(document).ready(() => {
        $('.slick-pre-init').removeClass('slick-pre-init');

        if( $('.partners__slider').length) {
            slider.initPartners();
        }
        if( $('.quotes-slider').length) {
            slider.initQuotes();
        }
        if( $('.feature-posts__wrapper').length) {
            slider.initPosts();
        }
    });
})(jQuery);



